import { STORAGE, STORES } from './constants';

function getStorageKey(store: STORAGE | STORES, key: string) {
  return `${store}__${key}`
}

export { getStorageKey };